import {
  Box,
  Button,
  Text,
  VStack,
  Input,
  Checkbox,
  HStack,
} from '@chakra-ui/react';
import React, { useState } from 'react';

import {
  assetVerification,
  error as commonError,
} from '@finley-technologies/common';

export const TextExternalReceivableIdRegEx = ({
  regEx,
  decodeBase64: configDecodeBase64,
}: {
  regEx: string;
  decodeBase64: boolean;
}) => {
  const [pathRegEx, setPathRegEx] = useState(regEx);
  const [pathInput, setPathInput] = useState<string>('');
  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const [decodeBase64, setDecodeBase64] = useState<boolean>(configDecodeBase64);
  const [externalReceivableId, setExternalReceivableId] = useState<
    string | null
  >('');

  const handleSubmit = (event: React.FormEvent) => {
    event.preventDefault();
    try {
      setErrorMessage(null);
      const newExternalReceivableId = assetVerification.extractExternalReceivableId(
        {
          filepath: pathInput,
          externalReceivableIdRegEx: pathRegEx,
          decodeBase64,
        },
      );
      setExternalReceivableId(newExternalReceivableId);
    } catch (error) {
      setErrorMessage(commonError.getErrorMessage(error));
    }
  };

  return (
    <Box mt={4} border="1px solid" padding={2}>
      <Text>Test externalReceivableIdRegEx</Text>
      <VStack mt={4} as="form" onSubmit={handleSubmit} align="start">
        <Text>externalReceivableIdRegEx:</Text>
        <HStack width="100%">
          <Input
            value={pathRegEx}
            onChange={(e) => setPathRegEx(e.target.value)}
            placeholder="Enter full path for the file"
          />
          <Checkbox
            isChecked={decodeBase64}
            onChange={(e) => setDecodeBase64(e.target.checked)}
          >
            decodeBase64
          </Checkbox>
        </HStack>

        <Text mt={2}>filePath:</Text>
        <Input
          value={pathInput}
          onChange={(e) => setPathInput(e.target.value)}
          placeholder="Enter full path for the file"
        />

        <Button type="submit">Test</Button>

        <Text>
          Extracted External Receivable Id:{' '}
          {`[${externalReceivableId ?? 'Not Found'}]`}
        </Text>
        {errorMessage && <Text color="red">{errorMessage}</Text>}
      </VStack>
    </Box>
  );
};
